export default "__VITE_ASSET__BPle74lC__"